const HBA1C = 'hba1c';
const WEIGHT = 'weight';
const WAIST = 'waist';

export { HBA1C, WEIGHT, WAIST };
